export default "__VITE_ASSET__cf94afec__"